import { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export interface FeatureItem {
  icon: LucideIcon;
  title: ReactNode;
  description: ReactNode;
}

interface FeatureGridProps {
  items: FeatureItem[];
  columns?: 2 | 3 | 4;
  className?: string;
}

export default function FeatureGrid({ items, columns = 4, className = '' }: FeatureGridProps) {
  const cols =
    columns === 2 ? 'md:grid-cols-2' : columns === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2 lg:grid-cols-4';
  return (
    <div className={`grid grid-cols-1 ${cols} gap-4 md:gap-6 ${className}`}>
      {items.map((item, idx) => {
        const Icon = item.icon;
        return (
          <div
            key={idx}
            className="group flex flex-col p-6 rounded-2xl border border-border bg-card hover:border-foreground/20 transition-colors"
          >
            <div className="h-10 w-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-4">
              <Icon className="h-5 w-5" />
            </div>
            <h3 className="text-base font-semibold text-foreground mb-1.5">{item.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
          </div>
        );
      })}
    </div>
  );
}
